// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"e0136efc","264":"7c05905a","323":"37466a2c","407":"db22e668","549":"c8d16e20","706":"b0670bf3","729":"b2dced93","848":"d15b9d2e","956":"fefb5373","996":"e07baabe"}[chunkId] + ".chunk.js";
};